import axios from "axios";
import defaultHeaders from "./default-headers";

export const getComplaintOptions = async () => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/quality-view/complaint-options`;
  const response = await axios.get(url);
  return response.data;
};

export const setReportComplaint = async (listingId, body) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/quality-view/${listingId}/report-complaint`;
  const response = await axios.post(url, body, {
    headers: {
      ...defaultHeaders,
    },
  });
  return response.data;
};

export const setUpdateComplaintUserInfo = async (complaintId, body) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/quality-view/${complaintId}/update-complaint-user-info`;
  const response = await axios.post(url, body, {
    headers: {
      ...defaultHeaders,
    },
  });
  return response.data;
};
